interface CloseIconProps extends React.SVGProps<SVGSVGElement> {
    width?: string | number;
    height?: string | number;
}

export const CloseIcon = ({ width = '16', height = '16', ...props }: CloseIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 7.69607 7.69607"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M0.0915291 0.0915293C0.213568 -0.0305097 0.411432 -0.0305098 0.533471 0.0915291L3.84803 3.40609L7.1626 0.0915291C7.28464 -0.0305097 7.4825 -0.0305097 7.60454 0.0915291C7.72658 0.213568 7.72658 0.411432 7.60454 0.533471L4.28998 3.84803L7.60454 7.1626C7.72658 7.28464 7.72658 7.4825 7.60454 7.60454C7.4825 7.72658 7.28464 7.72658 7.1626 7.60454L3.84803 4.28998L0.533471 7.60454C0.411432 7.72658 0.213568 7.72658 0.0915293 7.60454C-0.0305094 7.4825 -0.0305096 7.28464 0.0915293 7.1626L3.40609 3.84803L0.0915291 0.533471C-0.0305097 0.411432 -0.0305096 0.213568 0.0915291 0.0915293Z"
                fill="currentColor"
            />
        </svg>
    );
};
